import React from "react";
import RevealAnimation from "../RevealAnimation";
import "./ventureEnablementModelSection.scss";
import { FiUser, FiSettings, FiBox, FiDollarSign } from "react-icons/fi";

const VentureEnablementModelSection = () => {
  const pillars = [
    {
      title: "Man",
      icon: <FiUser />,
      provides: "Architects, engineers, designers, analysts",
      value: "Instant capability",
    },
    {
      title: "Method",
      icon: <FiSettings />,
      provides: "Big 4 Lite frameworks, CAB, accelerators",
      value: "Predictable outcomes",
    },
    {
      title: "Material",
      icon: <FiBox />,
      provides: "Blueprints, cloud credits, reusable assets",
      value: "Faster time to market",
    },
    {
      title: "Money",
      icon: <FiDollarSign />,
      provides: "Equity partnership, deferred billing",
      value: "Build without heavy upfront cost",
    },
  ];

  return (
    <section className="venture-enablement-section" id="enablement-model">
      <div className="body-container">
        <RevealAnimation>
          <div className="section-header">
            <span className="section-badge">The 4M Model</span>
            <h2>Venture Enablement Model</h2>
            <p className="subtitle">digiRyte’s Technology Capital Pillars</p>
            <p className="description">
              We don't just invest cash. We invest the four critical pillars
              every venture needs to succeed.
            </p>
          </div>
        </RevealAnimation>

        <div className="pillars-grid">
          {pillars.map((pillar, index) => (
            <RevealAnimation delay={index * 0.1} key={index}>
              <div className="pillar-card">
                <div className="pillar-icon">{pillar.icon}</div>
                <h3>{pillar.title}</h3>
                <div className="pillar-content">
                  <span className="label">What We Provide</span>
                  <p>{pillar.provides}</p>
                </div>
                <div className="pillar-value">
                  <span className="value-label">Value to Founder</span>
                  <p>{pillar.value}</p>
                </div>
              </div>
            </RevealAnimation>
          ))}
        </div>

        <RevealAnimation delay={0.4}>
          <div className="section-footer">
            <p>
              This is how digiRyte replaces{" "}
              <strong>“cash-only VC” with capability-first VC.</strong>
            </p>
          </div>
        </RevealAnimation>
      </div>
    </section>
  );
};

export default VentureEnablementModelSection;
